<template>
  <div class="top-wapper">
    <div class="slides">
      <van-swipe class="slide-list" :autoplay="3000">
        <van-swipe-item v-for="thumb in arrSlides" :key="thumb">
          <img :src="thumb">
        </van-swipe-item>
      </van-swipe>
    </div>
    <TablesInfo :tablesInfo="tablesInfo" />
    <van-icon v-if="arrSlides.length > 0" @click="showStore" name="shop" :class="'merchant-icon'" size="30" />
  </div>
</template>
<script>
import TablesInfo from '../../components/common/TablesInfo.vue'

export default {
  props: {
    arrSlides: {
      type: Array,
      default: () => {
        return []
      }
    },
    tablesInfo:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  components: {
    TablesInfo
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
    showStore () {
      this.$emit('evtShowStore')
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../assets/css/common.less');
</style>

